import WorkoutStep from "../components/workout/WorkoutStep";

export default function WorkoutPage(props) {
  return <WorkoutStep {...props} />;
}
